module.exports = __webpack_public_path__ + "static/media/icon-arrow.c86e1953.png";